/**
 *  @author ytnobody
 * @description  按需引入Vant
 */
import {
  Radio,
  RadioGroup,
  CheckboxGroup,
  Checkbox,
  Uploader,
  Switch,
  Area,
  Button,
  NavBar,
  List,
  Cell,
  Popup,
  Dialog,
  Divider,
  Form,
  Field,
  DatetimePicker,
  SwipeCell,
  Row,
  Col,
  Search,
  Icon,
  Tabbar,
  PullRefresh,
  Picker,
  Overlay,
  Progress,
  CellGroup,
  TabbarItem,
  Collapse,
  CollapseItem,
  NoticeBar,
  Tab,
  IndexBar,
  IndexAnchor,
  Tabs,
  Empty,
  Sticky,
  Skeleton,
  DropdownMenu,
  DropdownItem,
  Swipe,
    SwipeItem,
    Cascader
} from 'vant'
import { Image as VanImage } from 'vant';
const pluginsVant = [
  Radio,
  RadioGroup,
  CheckboxGroup,
  Checkbox,
  Uploader,
  Switch,
  Area,
  Button,
  NavBar,
  Tabbar,
  Dialog,
  Popup,
  Divider,
  Form,
  Field,
  DatetimePicker,
  TabbarItem,
  Collapse,
  PullRefresh,
  Progress,
  NoticeBar,
  Picker,
  Overlay,
  CellGroup,
  CollapseItem,
  List,
  Search,
  Cell,
  Row,
  Col,
  Icon,
  VanImage,
  Tab,
  Tabs,
  IndexBar,
  IndexAnchor,
  SwipeCell,
  Empty,
  Sticky,
  Skeleton,
  DropdownMenu,
  DropdownItem,
  Swipe,
    SwipeItem,
    Cascader
]
export const vantPlugins = {
  install: function (vm) {
    pluginsVant.forEach(item => {
      vm.component(item.name, item)
    })
  }
}

